import { PackageService } from "namirasoft-core";
import { BaseFinalCommand } from "./BaseFinalCommand";

export class VersionCommand extends BaseFinalCommand
{
    constructor(argv: string[])
    {
        super(argv, [], []);
    }
    override async exec()
    {
        let pkg = PackageService.getMain();
        this.app.logger.info("Name:        " + pkg.getName());
        this.app.logger.info("Title:       " + pkg.getTitle());
        this.app.logger.info("Description: " + pkg.getDescription());
        this.app.logger.info("Version:     " + pkg.getVersion());
    }
}